import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForEpisodeAllergology(
    service: ServiceForSelectedServiceType,
    serviceCode: ServiceCode.RespiAller
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.RespiAller:
            return {
                costs: 'eigen risico belast',
                steps: [
                    'Voer anamnese uit',
                    'Patiënt ontvangt een digitale vragenlijst',
                    'Voer de huidpriktest uit op de praktijk',
                    'Een Ksyos allergoloog beoordeelt het onderzoek',
                    'Je ontvangt het advies via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Voor diagnose en advies bij <strong>luchtwegallergie</strong>
                    </>
                ),
                title: 'Luchtwegallergie',
                waitingTime: 'binnen 5 werkdagen na versturen',
            };

        default:
            never(serviceCode);
    }
}
